/**
 * Description: App Expression config
 * User: Fay
 * Copyright(c) 2017 Taobao.com
 */

const APPConfig = {
  appName: 'alixm',
  WWSmiley: [
    '[smile_emoji]',
    '[shy_emoji]',
    '[tongue_emoji]',
    '[snicker_emoji]',
    '[love_emoji]',
    '[laughing_emoji]',
    '[dancing_emoji]',
    '[air_kiss_emoji]',
    '[comfort_emoji]',
    '[hug_emoji]',
    '[come_on_emoji]',
    '[victory_emoji]',
    '[good_emoji]',
    '[kiss_emoji]',
    '[anthomaniac_emoji]',
    '[toothy_laugh_emoji]',
    '[search_emoji]',
    '[calling_emoji]',
    '[afterwards_emoji]',
    '[miser_emoji]',
    '[good_idea_emoji]',
    '[grimace_emoji]',
    '[angel_emoji]',
    '[goodbye_emoji]',
    '[slobber_emoji]',
    '[enjoying_emoji]',
    '[erotic_emoji]',
    '[transfixed_emoji]',
    '[thinking_emoji]',
    '[confused_emoji]',
    '[wondering_emoji]',
    '[no_money_emoji]',
    '[boring_emoji]',
    '[doubt_emoji]',
    '[shhh_emoji]',
    '[wronged_emoji]',
    '[shaking_head_emoji]',
    '[cold_emoji]',
    '[awkward_emoji]',
    '[giggle_emoji]',
    '[no_way_emoji]',
    '[helpless_emoji]',
    '[sweating_emoji]',
    '[desolate_emoji]',
    '[sleepy_emoji]',
    '[gosh_emoji]',
    '[sadness_emoji]',
    '[aggrieved_emoji]',
    '[sob_emoji]',
    '[break_into_tears_emoji]',
    '[cry_emoji]',
    '[I_give_up_emoji]',
    '[sorry_emoji]',
    '[goodbye_with_tears_emoji]',
    '[frown_emoji]',
    '[too_tired_emoji]',
    '[threw_up_emoji]',
    '[recite_emoji]',
    '[surprise_emoji]',
    '[consternation_emoji]',
    '[shut_up_emoji]',
    '[owe_flat_emoji]',
    '[despise_you_emoji]',
    '[furious_emoji]',
    '[mad_emoji]',
    '[Fortuna_emoji]',
    '[learn_from_Lei_Feng_emoji]',
    '[Kung_Hei_Fat_Choi_emoji]',
    '[waiter_emoji]',
    '[boss_emoji]',
    '[evil_emoji]',
    '[solo_emoji]',
    '[CS_emoji]',
    '[invisible_man_emoji]',
    '[bomb_emoji]',
    '[screaming_emoji]',
    '[beautiful_lady_emoji]',
    '[handsome_emoji]',
    '[Lucky_Cat_emoji]',
    '[deal_emoji]',
    '[applaud_emoji]',
    '[shake_hands_emoji]',
    '[red_lips_emoji]',
    '[rose_emoji]',
    '[residual_flowers_emoji]',
    '[sweetheart_emoji]',
    '[heart_breaking_emoji]',
    '[money_emoji]',
    '[shopping_emoji]',
    '[gift_emoji]',
    '[email_emoji]',
    '[phone_call_emoji]',
    '[cheers_emoji]',
    '[clock_emoji]',
    '[waiting_emoji]',
    '[too_late_emoji]',
    '[airplane_emoji]',
    '[Alipay_emoji]',
  ],
  WWSmileyPath: '//g.alicdn.com/crm/static/0.1.0/ww/',
  LYSmileyPath: '//g.alicdn.com/crm/static/0.2.0/lw/',
  LYSmiley: {
    '001': '傻笑',
    '002': '苦笑',
    '003': '晕',
    '004': '嘟嘴',
    '005': '红心',
    '006': '害羞',
    '007': '吐舌头',
    '008': '微笑',
    '009': '雷到',
    '010': '扣鼻屎',
    '011': '悲伤',
    '012': '愤怒',
    '013': '大怒',
    '014': '惊悚',
    '015': '吓人',
    '016': '呕吐',
    '017': '鼓掌',
    '018': '财迷',
    '019': '可爱的笑',
    '020': '疑问',
    '021': '满意的笑',
    '022': '装酷',
    '023': '闭嘴',
    '024': '大哭',
    '025': '打盹',
    '026': '欠揍',
    '027': '囧',
    '028': '猪',
    '029': '火星人',
    '030': '奥特曼',
    '031': '钱',
    '032': '心',
    '033': '心碎',
    '034': '乌鸦',
    '035': '骷髅',
    '036': '咖啡',
    '037': '米饭',
    '038': '购物袋',
    '039': '灯泡',
    '040': '赞',
    '041': '弱爆',
    '042': '胜利',
    '043': 'iloveu',
    '044': 'ok',
    '045': '握手',
    '046': '菜刀',
    '047': '大笑',
    '048': '悲',
    '049': '汗',
    '050': '脸红',
    '051': '喜欢',
    '052': '惊讶',
    '053': '生日蛋糕',
    '054': '礼物',
    '055': '太阳',
    '056': '月亮',
    '057': '浮云',
    '058': '下雨',
    '059': '雪花',
    '060': '闪电',
    '061': '雨伞',
    '062': '水果',
    '063': '屎',
    '064': '嘴唇',
    '065': '红包',
  },
};

export default APPConfig;



// WEBPACK FOOTER //
// ./src/component/smiley/config.js